import { render, staticRenderFns } from "./PartnerDelivery.vue?vue&type=template&id=11fb68bf&"
import script from "./PartnerDelivery.vue?vue&type=script&lang=js&"
export * from "./PartnerDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports